import { useCountUp } from '../../animations/useCountUp';

/**
 * Generic count-up number for stat cards — wraps the existing useCountUp
 * hook (already built for the landing page's StatCounter) so dashboard
 * cards can drop in a currency/plain-number count-up without repeating the
 * gsap boilerplate. Animates once on mount per the design system's "first
 * mount only, skip on refetches" rule — useCountUp re-runs its tween
 * whenever `value` changes, so callers that refetch in place (e.g. RTK
 * Query cache updates) should key this component with something stable
 * per screen-load if they want to guarantee no re-animation on a silent
 * background refetch that happens to change the number.
 */
export default function CountUpStat({ value, formatter, className, duration = 1.1 }) {
  const ref = useCountUp(Number(value) || 0, { duration, formatter });
  return (
    <p ref={ref} className={className}>
      {formatter ? formatter(0) : '0'}
    </p>
  );
}
